export const TabsSyncMessages = {
  Logout: 'logout',
  Login: 'login',
} as const

export type TabsSyncMessages = typeof TabsSyncMessages[keyof typeof TabsSyncMessages]
